<form [formGroup]="formGroup">
  <div class="form-field">
    <app-input
      label="Evacuation Perimeter (m)"
      i18n-label="@@evacuationPerimeterLabel"
      placeholder="Enter value"
      i18n-placeholder="@@enterValue"
      formControlName="evacuationPerimeterM"
      [readonly]="true"
      valueLabel="Meter Perimeter"
      i18n-valueLabel="@@meterPerimeter">
    </app-input>
  </div>
  <div class="form-field">
    <app-input
      label="Secure Airspace Perimeter (m)"
      i18n-label="@@airspacePerimeterLabel"
      placeholder="Enter value"
      i18n-placeholder="@@enterValue"
      formControlName="secureAirspacePerimeterM"
      [readonly]="true"
      valueLabel="Meter Perimeter"
      i18n-valueLabel="@@meterPerimeter">
    </app-input>
  </div>
  <div class="form-field">
    <app-input
      label="Secure Seaward Perimeter (m)"
      i18n-label="@@seawardPerimeterLabel"
      placeholder="Enter value"
      i18n-placeholder="@@enterValue"
      formControlName="secureSeawardPerimeterM"
      [readonly]="true"
      valueLabel="Meter Perimeter"
      i18n-valueLabel="@@meterPerimeter">
    </app-input>
  </div>
  <div class="form-field">
    <app-button-group
      label="Infrastructure Present? (Yes/No)"
      i18n-label="@@infrastructurePresentLabel"
      [options]="yesNoOptions"
      formControlName="infrastructurePresent"
      [errorMessage]="formGroup.get('infrastructurePresent')?.errors"
      [touched]="formGroup.get('infrastructurePresent')?.touched">
    </app-button-group>
  </div>
  <div *ngIf="formGroup.get('infrastructurePresent')?.value === true">
    <div class="form-field">
      <app-button-group
        label="Radio Transmitters? (Yes/No)"
        i18n-label="@@radioTransmittersLabel"
        [options]="yesNoOptions"
        formControlName="radioTransmitters"
        [errorMessage]="formGroup.get('radioTransmitters')?.errors"
        [touched]="formGroup.get('radioTransmitters')?.touched">
      </app-button-group>
    </div>
    <div class="form-field">
      <app-button-group
        label="Power Lines? (Yes/No)"
        i18n-label="@@powerLinesLabel"
        [options]="yesNoOptions"
        formControlName="powerLines"
        [errorMessage]="formGroup.get('powerLines')?.errors"
        [touched]="formGroup.get('powerLines')?.touched">
      </app-button-group>
    </div>
    <div class="form-field">
      <app-button-group
        label="Fuel Tanks? (Yes/No)"
        i18n-label="@@fuelTanksLabel"
        [options]="yesNoOptions"
        formControlName="fuelTanks"
        [errorMessage]="formGroup.get('fuelTanks')?.errors"
        [touched]="formGroup.get('fuelTanks')?.touched">
      </app-button-group>
    </div>
    <div class="form-field">
      <app-button-group
        label="Buildings In Frag Zone? (Yes/No)"
        i18n-label="@@buildingsFragZoneLabel"
        [options]="yesNoOptions"
        formControlName="buildingsInFragZone"
        [errorMessage]="formGroup.get('buildingsInFragZone')?.errors"
        [touched]="formGroup.get('buildingsInFragZone')?.touched">
      </app-button-group>
    </div>
  </div>
  <div class="form-field">
    <app-input
      [label]="additionalHazardsLabel"
      placeholder="Explain"
      i18n-placeholder="@@explainPlaceholder"
      type="textarea"
      formControlName="additionalHazards">
    </app-input>

  </div>
</form>
